import Logo from '../../assets/skyfirst-logo.png'
export default {
  name: 'Login',
  data: () => {
    return {
      logo: Logo
    }
  }
}
